import type React from 'react';
import { useEffect, useState } from 'react';
import type { MagneticWallItemSize } from './MagneticWallItem';
import { MAGNETIC_WALL_MIN_WIDTH } from './PostLayoutSizes';

function useMagneticWallItemSize(
  containerRef: React.RefObject<HTMLElement>,
): MagneticWallItemSize {
  const [size, setSize] = useState<MagneticWallItemSize>('compact');

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return undefined;

    function handleWidthChange(width: number) {
      if (width >= MAGNETIC_WALL_MIN_WIDTH) {
        setSize('full');
      } else {
        setSize('compact');
      }
    }

    handleWidthChange(element.offsetWidth);

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]?.contentRect;
      if (entry) {
        handleWidthChange(entry.width);
      }
    });
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  }, [containerRef]);

  return size;
}

export default useMagneticWallItemSize;
